import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { NEWS, NEWS_META, NEWS_PATH, formatNewsDate } from "@/lib/news";
import { Reveal } from "./Section";
import { ArrowUpRight } from "lucide-react";

export default function AktuellesTeaser() {
  const { lang } = useLang();
  const n = NEWS[0];
  const m = NEWS_META[lang];
  return (
    <section id="aktuelles" data-testid="section-aktuelles" className="relative bg-[#0F1114] text-white py-24 md:py-32 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-3">
              <div className="flex items-center gap-3 text-[11px] tracking-[0.35em] uppercase text-white/45 font-display">
                <span className="h-px w-8 bg-white/40" />
                {m.teaserKicker}
              </div>
              <time dateTime={n.date} className="mt-6 block text-[11px] tracking-[0.3em] uppercase text-white/45 font-display" data-testid="aktuelles-teaser-date">
                {formatNewsDate(n.date, lang)}
              </time>
            </div>
            <div className="lg:col-span-9 max-w-3xl">
              <Link to={`${NEWS_PATH[lang]}#${n.slug}`} data-testid="aktuelles-teaser-title" className="group block">
                <h2 className="font-display font-light tracking-[-0.02em] leading-[1.1] text-white group-hover:text-[#F5D77A] transition-colors" style={{ fontSize: "clamp(1.6rem, 2.8vw, 2.5rem)" }}>
                  {n[lang].title}
                </h2>
              </Link>
              <p className="mt-6 text-white/65 leading-[1.7] text-[15px] md:text-base">{n[lang].paragraphs[0]}</p>
              <Link to={NEWS_PATH[lang]} data-testid="aktuelles-teaser-all" className="mt-8 group inline-flex items-center gap-3 w-fit text-[#F5D77A] hover:text-white transition-colors font-display font-light text-lg tracking-[-0.01em]">
                {m.all}
                <ArrowUpRight className="h-4 w-4 opacity-60 transition-all group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
